import { cn } from "../../libs/utils"

/**
 * Nuvve "V" brand mark — always the green mark, in every theme.
 *
 * It used to swap to white on dark backgrounds (which is what the 2018 brand
 * sheet prescribes for dark surfaces), but the mark is the company's colour and
 * reads as the company's colour: keeping it green in light, dark and auto is a
 * deliberate product decision. Pass sizing via `className`.
 */
export function BrandMark({ className, alt = "Nuvve" }: { className?: string; alt?: string }) {
  return <img src="/nuvve-mark-green.png" alt={alt} className={cn(className)} />
}
